import { render, staticRenderFns } from "./userAndPassword.vue?vue&type=template&id=8340dfa4"
import script from "./userAndPassword.vue?vue&type=script&lang=js"
export * from "./userAndPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports